import en from './en';

export const authTranslations: NamespaceTranslations<keyof typeof en> = {
  en,
};
